/** The "what / why / how to read" explanation behind the usual information icon. */
import { useState, type ReactNode } from 'react'
import { IconInfoCircle } from '@tabler/icons-react'
import { Popover } from '../../../ui/kit'

export interface HelpContent { what: ReactNode; why: ReactNode; read: ReactNode }

export function HelpPopover({ label, help }: { label: string; help: HelpContent }) {
  const [open, setOpen] = useState(false)
  return (
    <Popover open={open} onClose={() => setOpen(false)} align="end" width={380} anchor={
      <button type="button" className="fin-help-btn" aria-label={`Explain ${label}`} aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(value => !value)}><IconInfoCircle className="ic-sm" aria-hidden="true" /></button>
    }>
      <div className="pop-title">{label}</div>
      <div className="fin-help">
        <section><small>What it is</small><div>{help.what}</div></section>
        <section><small>Why it matters to you</small><div>{help.why}</div></section>
        <section><small>How to read it</small><div>{help.read}</div></section>
      </div>
    </Popover>
  )
}
